import { ReleaseHighlight } from "@/entities/release-highlight";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type ReleaseHighlightStore = {
    gelezenBerichtIds: string[];
    markAlsGelezen: (berichtId: string, zichtbareBerichten: ReleaseHighlight[]) => void;
};

export const useReleaseHighlightStore = create<ReleaseHighlightStore>()(
    persist(
        (set, get) => ({
            gelezenBerichtIds: [],
            markAlsGelezen: (berichtId: string, zichtbareBerichten: ReleaseHighlight[]) => {
                const gelezenBerichtIds = ReleaseHighlight.keepVisibleMessages(
                    [...new Set([...get().gelezenBerichtIds, berichtId])],
                    zichtbareBerichten
                );

                set({ gelezenBerichtIds });
            },
        }),
        // Legacy storage key: renaming would reset de gelezen-status van bestaande gebruikers.
        { name: "nieuw-in-sein-gelezen-status" }
    )
);
